const createDateWithoutTimezone = (date = null) => {
  const tempDate = date ? new Date(date) : new Date();

  const timezoneOffset = tempDate.getTimezoneOffset();

  tempDate.setMinutes(-timezoneOffset);

  return tempDate;
};

export default createDateWithoutTimezone;
